import { useNavigate, useParams } from 'react-router-dom';
import { useSchoolGoTo } from './useSchoolGoTo';
import { useUser } from './context/useUser';

export function useCahierJournalGoTo() {
  const navigate = useNavigate();
  const goTo = useSchoolGoTo();
  const user = useUser();
  const { userId, token } = useParams<{
    token: string;
    userId: string;
  }>();

  if (user.guestMode?.enabled && token && userId) {
    return (path: string) => navigate(`/shares/${userId}/t/${token}/${path}`);
  }

  return goTo;
}
